import React from 'react';
import { Award, ShieldCheck, Package, Users, TrendingDown, Scissors } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Advantages = () => {
  const { t } = useTranslation();
  
  const advantages = [
    {
      titleKey: 'advantages.items.experience.title',
      descriptionKey: 'advantages.items.experience.description',
      icon: Award
    },
    {
      titleKey: 'advantages.items.quality.title',
      descriptionKey: 'advantages.items.quality.description',
      icon: ShieldCheck
    },
    {
      titleKey: 'advantages.items.stock.title',
      descriptionKey: 'advantages.items.stock.description',
      icon: Package
    },
    {
      titleKey: 'advantages.items.service.title',
      descriptionKey: 'advantages.items.service.description',
      icon: Users
    },
    {
      titleKey: 'advantages.items.price.title',
      descriptionKey: 'advantages.items.price.description',
      icon: TrendingDown
    },
    {
      titleKey: 'advantages.items.custom.title',
      descriptionKey: 'advantages.items.custom.description',
      icon: Scissors
    }
  ];
  
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="font-semibold text-sm uppercase tracking-wider text-cmv-green">
            {t('advantages.label')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold mt-4 mb-6 text-gray-900">
            {t('advantages.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('advantages.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => {
            const Icon = advantage.icon;
            
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-cmv-green"
              >
                <div className="w-16 h-16 bg-cmv-green/10 rounded-lg flex items-center justify-center mb-6">
                  <Icon size={32} className="text-cmv-green" />
                </div>
                
                <h3 className="text-xl font-bold mb-4 text-gray-900">
                  {t(advantage.titleKey)}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {t(advantage.descriptionKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
